<template>
  <footer class="footer footer-squared">
    <div class="container footer-inner">
      <div class="d-flex justify-content-center align-items-center">
        <ul class="nav nav-pills d-flex align-items-center gap-3">
          <li class="nav-item">
            <a
              class="nav-link d-flex align-items-center justify-content-center"
              @click="$router.back()"
              v-if="this.$route.path != '/'"
            >
              <span>
                <i class="nav-icon bi bi-arrow-left"></i>
                <span class="nav-text">Voltar</span>
              </span>
            </a>
          </li>
          <li class="nav-item square-footerbtn">
            <a
              class="nav-link d-flex align-items-center justify-content-center"
              id="centermenubtn"
              @click="navigateHome"
            >
              <span class="bg-theme">
                <i class="nav-icon bi bi-house"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-powered-by">
      Powered by AID - Automatização e Inovação Digital
    </div>
  </footer>

  <!-- PWA app install toast message -->
  <div class="position-fixed bottom-0 start-50 translate-middle-x z-index-99">
    <div
      class="toast rounded-6 mb-3 overflow-hidden"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      id="toastinstall"
      data-bs-animation="true"
    >
      <div class="toast-header">
        <img src="/pic/Logo.png" class="rounded me-2" alt="..." />
        <strong class="me-auto">Install PWA App</strong>
        <small>now</small>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
      <div class="toast-body">
        <div class="row">
          <div class="col">
            Click "Install" to install PWA app & experience indepedent.
          </div>
          <div class="col-auto align-self-center ps-0"></div>
        </div>
      </div>
      <button class="btn-default btn btn-lg rounded-0 w-100" id="addtohome">
        Install
      </button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    unreadCount() {
      return this.$store.getters.getUnreadCount;
    },
  },
  methods: {
    navigateHome() {
      if (this.$route.path === "/") {
        window.dispatchEvent(new CustomEvent("app:refresh-current-view"));
        return;
      }

      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.footer .container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 10px 4px;
}

.footer-inner {
  max-width: 640px;
}

.footer-powered-by {
  text-align: center;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  opacity: 0.75;
  padding: 0 10px 8px;
}

.footer .nav {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  gap: 12px;
}

.footer .nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 40px;
  min-height: 40px;
  padding: 8px 12px;
  border-radius: 999px;
  transition: all 0.3s ease;
}

.footer .nav-link:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.1);
  transform: translateY(-1px);
}

.square-footerbtn .nav-link {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  padding: 0;
}

.square-footerbtn .bg-theme {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.nav-icon {
  font-size: 1.1rem;
}

.nav-text {
  margin-left: 5px;
  font-size: 0.85rem;
}

/* Responsividade */
@media (max-width: 768px) {
  .footer .nav {
    gap: 10px;
  }

  .square-footerbtn .nav-link {
    width: 42px;
    height: 42px;
  }

  .footer-powered-by {
    font-size: 0.7rem;
    padding-bottom: 6px;
  }

  .nav-text {
    display: none;
  }
}
</style>
